// extracted by mini-css-extract-plugin
export default {"responsiveScrollableWrapper":"_6M6JB"};